import { applyMiddleware, compose, createStore as createReduxStore } from 'redux'
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import CONFIG from '../config'
import translationsObject from '../i18n'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import makeRootReducer from './reducers'
import { updateLocation } from './location'

const createStore = (initialState = {}) => {
  const history = createHistory();

  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [thunk];

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [];
  let composeEnhancers = compose;

  if (__DEV__) {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createReduxStore(
    makeRootReducer(),
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware),
      ...enhancers
    )
  );

  syncTranslationWithStore(store);
  console.log(translationsObject);
  store.dispatch(loadTranslations(translationsObject));
  store.dispatch(setLocale(CONFIG.DEFAULT_LANGUAGE || 'en_US'));

  store.asyncReducers = {};

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime
  store.unsubscribeHistory = history.listen(updateLocation(store));

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }

  return store
}

export default createStore



// WEBPACK FOOTER //
// ./src/store/createStore.js